module.exports.getEndPoint = function() {
  return window["config"].BACKEND_DOMAIN
}
